module.exports = __webpack_public_path__ + "static/media/rapidNaming-intro4.ac6310fc.mp3";